import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

const Container = styled(FlexBox)`
  flex-grow: 1;
  min-height: 44px;
  gap: 20px;
  position: relative;
  align-items: flex-start;
  padding: 8px 0;
`;

const SearchRow = ({ children, collapsible, ...props }) => {
  return (
    <Container className={`search-row ${collapsible ? 'collapsible' : ''}`} {...props}>
      {children}
    </Container>
  );
};

SearchRow.propTypes = {
  children: PropTypes.node,
  collapsible: PropTypes.bool,
};

SearchRow.defaultProps = {
  collapsible: false,
};

export default SearchRow;
